const EXPLAINER_PREFIX = "scoutux:product-change-explainer-dismissed";

export function isProductChangeExplainerDismissed(userId: string) {
  return readFlag(explainerStorageKey(userId));
}

export function dismissProductChangeExplainer(userId: string) {
  writeFlag(explainerStorageKey(userId));
}

function explainerStorageKey(userId: string) {
  return `${EXPLAINER_PREFIX}:${userId}`;
}

function readFlag(key: string) {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function writeFlag(key: string) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(key, "1");
  } catch {
    // Ignore quota / private-mode failures; session state still covers this visit.
  }
}
